export default __webpack_public_path__ + "static/media/Habitat-Logo-Animation-V2.mp4";